import { FC } from "react";
import { Image } from "@chakra-ui/react";
import SunriseFlourishImage from "~/images/sunrise-pink-down-right.svg";

export const PlanFlourish: FC = () => {
  return (
    <Image
      alt=""
      bottom="-8rem"
      display={{ base: "none", lg: "initial" }}
      position="absolute"
      right="-8rem"
      src={SunriseFlourishImage}
    />
  );
};
